import { QueryClient } from '@tanstack/react-query';

type InvalidateDataUploadFilesOptions = {
  clientId?: string;
  familyId?: string;
};

export function invalidateDataUploadFiles(
  queryClient: QueryClient,
  { clientId, familyId }: InvalidateDataUploadFilesOptions,
) {
  const invalidations = [];

  if (clientId) {
    invalidations.push(
      queryClient.invalidateQueries({ queryKey: ['clients', clientId, 'data-upload-files'] }),
    );
  }

  if (familyId) {
    invalidations.push(
      queryClient.invalidateQueries({ queryKey: ['families', familyId, 'data-upload-files'] }),
    );
  } else if (clientId) {
    invalidations.push(
      queryClient.invalidateQueries({
        predicate: query =>
          query.queryKey[0] === 'families' && query.queryKey[2] === 'data-upload-files',
      }),
    );
  }

  return Promise.all(invalidations);
}
